import { useEffect } from 'react';
import moment from 'jalali-moment';
import { useNavigate, useSearchParams } from 'react-router-dom';

import {EGFR,Wizard} from 'modules/report/components/report-components/therapeutic-adjustment/calculators'
import {ASCVD} from 'modules/report/components/report-components/therapeutic-adjustment/calculators/ascvd'
import { usePatientsContext } from 'store/context/patient-context';
import {useMediaQuery} from "hooks/useMediaQuery";

const calcUserAge = (birthdate) => {
  const today = moment();
  const gregorianBirthdate = moment(birthdate, 'jYYYY/jM/jD').format(
    'YYYY-MM-DD'
  );
  return today.diff(gregorianBirthdate, 'years');
};

const CalculatorsPage = () => {
  const navigate = useNavigate();
  const {
    userInfo: { isMale, birthDate }
  } = usePatientsContext() || {};
  const [searchParams] = useSearchParams();
  const calculatorType = searchParams.get('type');

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const userAge = calcUserAge(birthDate);
  const isDesktop = useMediaQuery('(min-width: 1024px)');

  return (
    <div style={{ margin: `${isDesktop?'0px 16px 2rem':'88px 16px 2rem'}` }}>
      <Wizard
        titleText={`${calculatorType}${
          calculatorType === 'Ascvd' ? '+' : ''
        } Calculator`}
        backStepHandler={() => navigate(-1, { replace: true })}
      >
        {calculatorType == 'eGFR' ? (
          <EGFR userAge={userAge} isMale={isMale} />
        ) : (
          <ASCVD userAge={userAge} isMale={isMale} />
        )}
      </Wizard>
    </div>
  );
};

export default CalculatorsPage;
